import { ArrowRight, ShieldCheck, Building, TrendingUp } from 'lucide-react';
import { Button } from './ui/button';

const BONZA_LOGO = "https://customer-assets.emergentagent.com/job_2b31ab0e-18bf-40dd-b209-ee04ef532201/artifacts/pjhpmexv_Colour%20Landscape%20Logo%20-%20Large%20file%20size.png";
const BONZA_LOGO_LIGHT = "https://customer-assets.emergentagent.com/job_value-finder-au/artifacts/g4de4ts7_Grey%20Landscape%20Logo.png";

const POINTS = [
  { Icon: ShieldCheck, text: 'Built for Australian small business owners' },
  { Icon: Building, text: 'Designed for businesses under $3 million' },
  { Icon: TrendingUp, text: 'No obligation — just useful insight' },
];

export const HeroSection = ({ onStart }) => {
  return (
    <div className="bonza-hero" data-testid="hero-section">
      <div className="max-w-2xl mx-auto">
        <div className="mb-6">
          <img src={BONZA_LOGO_LIGHT} alt="Bonza Business & Franchise Sales" className="bonza-hero-logo-light h-12 md:h-16 mx-auto" data-testid="bonza-logo" />
          <img src={BONZA_LOGO} alt="Bonza Business & Franchise Sales" className="bonza-hero-logo-colour h-12 md:h-16 mx-auto" data-testid="bonza-logo-colour" />
        </div>

        <p className="bonza-eyebrow" data-testid="hero-eyebrow">Australia's leading business brokerage</p>
        <h1 className="bonza-hero-title mb-4" data-testid="hero-title">
          What Is Your Business Worth in Today's Market?
        </h1>
        <p className="bonza-hero-subtitle text-lg mb-2" data-testid="hero-subtitle">
          Get an instant estimated price range based on your business details and current buyer demand across Australia.
        </p>

        <div className="bonza-hero-points flex flex-wrap items-center justify-center gap-4 mt-6 mb-8 text-sm">
          {POINTS.map(({ Icon, text }) => (
            <div key={text} className="flex items-center gap-2">
              <Icon className="w-4 h-4" />
              <span>{text}</span>
            </div>
          ))}
        </div>

        <Button
          data-testid="start-valuation-btn"
          onClick={onStart}
          className="bonza-btn-primary bonza-hero-cta h-14 px-8 text-base font-semibold rounded-full shadow-lg hover:shadow-xl"
        >
          Start My Free Valuation
          <ArrowRight className="w-5 h-5 ml-2" />
        </Button>
      </div>
    </div>
  );
};
